import React from 'react';
import { MenuItem as BSMenuItem, MenuItemProps as BSMenuItemProps } from "react-bootstrap";
import { useDirtyWarningContext, DirtyWarningConfirmProps } from '../../DirtyWarning/DirtyWarningContext';

export interface DropdownItemProps extends BSMenuItemProps, DirtyWarningConfirmProps  {

}

export const DropdownItem: React.FC<DropdownItemProps> = (props) => {
   const context = useDirtyWarningContext();   
   const { onClick, dirtyWarningMessage, resetDirtyTracking = false, showDirtyWarning = false, ...otherProps } = props;

   const handleClick = async (e: any) => {
      const proceed = !showDirtyWarning || !context.dirty || await context.confirm(dirtyWarningMessage);
      if (proceed) {
         if (onClick) onClick(e);
         if (resetDirtyTracking) context.setDirty(false);
      }
  }

   return (
      <BSMenuItem onClick={handleClick} {...otherProps}>
         {props.children}
      </BSMenuItem>
   )
}

(DropdownItem as any).displayName = 'DropdownItem';